<div class="container">
  <div class="box otp">
    <div class="box-header" *ngIf="!isFund">
      <h1 class="header1">تایید</h1>
      <button class="btn helpBtn" data-toggle="modal" data-target="#help1"></button>
    </div>
    <div class="box-body">
      <p class="farsiNumber" style="direction: rtl;">{{infoTitle}}</p>
      <div class="form-group">
        <input maxlength="1" class="form-control" type="tel" [(ngModel)]="codeArray[0]"
               (keydown)="backward($event, 0)" (keyup)="onKeydown($event)" (paste)="handlePaste($event)">
        <input maxlength="1" class="form-control" type="tel" [(ngModel)]="codeArray[1]"
               (keydown)="backward($event, 1)" (keyup)="onKeydown($event)">
        <input maxlength="1" class="form-control" type="tel" [(ngModel)]="codeArray[2]"
               (keydown)="backward($event, 2)" (keyup)="onKeydown($event)">
        <input maxlength="1" class="form-control" type="tel" [(ngModel)]="codeArray[3]"
               (keydown)="backward($event, 3)" (keyup)="onKeydown($event)">
        <input maxlength="1" class="form-control" type="tel" [(ngModel)]="codeArray[4]"
               (keydown)="backward($event, 4)" (keyup)="onKeydown($event)">
      </div>
      <div class="btnContainer" [ngClass]="{'flex-column': isFund}">
        <button class="btn purpleBtn" #submitbutton [class.spinner]="isLoading" [disabled]="isLoading" (click)="submitCode()">تایید</button>
        <button class="btn resendBtn" [disabled]="disabledResend" (click)="resendCode()">ارسال مجدد<app-timer
          (notifyStop)="disabledResend=false"></app-timer></button>
      </div>
  </div>
  <app-footer></app-footer>
</div>
</div>

<app-snack-bar></app-snack-bar>
<div class="modal fade" tabindex="-1" role="dialog" id="help1" aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <h1 class="header1"> {{loginHelp.title}}:</h1>
        <p [innerHTML]="loginHelp.msg"></p>
      </div>
      <div class="modal-footer simple-footer">
        <button data-dismiss="modal">بستن</button>
      </div>
    </div>
  </div>
</div>